// Cosmetic scaling follows the authored effect curve; it never applies damage.
const bounded = (value, fallback, min, max) => Math.max(min, Math.min(max, Number.isFinite(value) ? value : fallback))
export const castPresentationKey = ({ actorId, skillId, targetId }) => JSON.stringify([actorId, skillId, targetId || actorId])

export function resolvePresentationPower(skill, { skillLevel = 1, power = 1 } = {}) {
  const level = Math.floor(bounded(skillLevel, 1, 1, skill?.levels?.max || 20))
  const ritualPower = bounded(power, 1, .1, 4)
  const effect = skill?.effects?.find(fx => ['damage', 'heal', 'shield', 'drain'].includes(fx.type) && fx.base > 0)
  const nominal = effect ? Math.max(0, effect.base + (level - 1) * (effect.perLevel || 0)) : null
  const levelScale = effect ? nominal / effect.base : 1
  return { skillLevel: level, power: ritualPower, nominalPower: nominal === null ? null : nominal * ritualPower,
    strength: bounded(levelScale * ritualPower, 1, .1, 4) }
}
